(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CopyAddress", [], factory);
	else if(typeof exports === 'object')
		exports["CopyAddress"] = factory();
	else
		root["CopyAddress"] = factory();
})(this, function() {
return 